module.exports = __webpack_public_path__ + "img/gossipStamp.b32392d0.png";